import React from "react";
import { CardTracking } from "../CardTracking";
import { Button, Paragraph, Spacing } from "@sicredi/react";
import styles from "./styles.module.scss";
import { ITrackingComponents } from "../model";
import { formatDate } from "#/contextProver/ContextProverServices";

export const PagamentoTracking: React.FC<ITrackingComponents> = ({
  state,
  paragraphSize,
  isIconWarning,
  vencimentoBoleto,
  onClick,
  isContratoAssinado,
}) => {
  return (
    <div>
      <CardTracking
        title="Pagamento"
        state={state}
        isIconClock={!isContratoAssinado}
        isIconWarning={isIconWarning && !state}
      >
        {!isContratoAssinado && <Spacing appearance="x-large" />}

        {isContratoAssinado && !state && (
          <>
            <Paragraph size={paragraphSize(state)} weight="normal">
              O boleto de adesão está disponível. Após pagamento, aguarde a
              compensação.
            </Paragraph>

            {vencimentoBoleto && vencimentoBoleto !== "0001-01-01 00:00:00" && (
              <Paragraph size="medium" weight="bold">
                {`Vencimento: ${formatDate(vencimentoBoleto)}`}
              </Paragraph>
            )}

            <div className={styles.button_container}>
              <Button
                appearance="primary"
                className={styles.button_primary}
                onClick={onClick}
              >
                Pagar boleto
              </Button>
            </div>
          </>
        )}

        {state && (
          <>
            <Paragraph size={paragraphSize(state)} weight="normal">
              Boleto pago.
            </Paragraph>

            <Spacing appearance="large" />
          </>
        )}
      </CardTracking>
    </div>
  );
};
